export default __webpack_public_path__ + "media/images/react_icons/search-f234a5b76982cb332d2dd0f91e3cb36e.svg";